<template>
  <div class="login" v-loading="loading">
  </div>
</template>

<script>
export default {
  name: 'OAuthLogin',
  data() {
    return {
      loading: true
    }
  },
  created() {
    this.$parent.disableMenu();
    this.$axios.get('/gwr/auth/auth')
      .then((response) => {
        this.loading = false;
        this.$parent.setUser(response.data);
        if (response.status == '200') {
          this.$parent.enableMenu();
          if (this.$parent.isSeishain) {
            this.$parent.switchMenu('KimmuJisseki', '/kimmu');
          } else {
            this.$parent.switchMenu('KimmuJissekiK', '/kimmuK');
          }
        } else {
          this.$notify({
            title: '新規ユーザー',
            message: '初回ログイン時は社員情報を登録してください。',
            type: 'info'
          });
          //if (this.$parent.isSeishain) {
            this.$parent.switchMenu('ShainSettei', '/shain', { shainShimei: response.data });
          //} else {
          //  this.$parent.switchMenu('ShainSetteiK', '/shainK', { shainShimei: response.data });
          //}
        }
      })
      .catch((error) => {
        if (error.response.status == '401') {
          location.href='/oauth2/authorization/azure';
        } else {
          this.loading = false;
          this.$notify({
            title: '認証エラー',
            message: error.response.statusText,
            type: 'error'
          });
        }
      });
  },
}
</script>

<style scoped>
</style>
